import { useEffect, useState } from "react";

import ImageComponent from "common/components/Image";
import { useNavigate } from "common/router/hooks";

import { useBreakpoints } from "client/common/hooks";
import LoadingContainer from "client/common/components/loading/LoadingContainer";

import { LoyaltyProgramMarketingBanner } from "../types";

import styles from "../styles/LoyaltyProgramMarketingBanners.module.less";

type LoyaltyProgramMarketingBannersProps = {
  banners: LoyaltyProgramMarketingBanner[];
};

const LoyaltyProgramMarketingBanners = ({ banners }: LoyaltyProgramMarketingBannersProps) => {
  const navigate = useNavigate();
  const { isTabletPortraitAndSmaller } = useBreakpoints();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // TODO - [sc-62733] loyalty_programs - support multiple banners. Will need to think through UX with rotating banners,
  // navigation controls, different banner sizes, etc. For now, just show the first banner, the results will be ordered by priority.
  const currentBanner = banners[0];
  const imageUrl = isTabletPortraitAndSmaller
    ? currentBanner.marketing_banner_config.image_url_mobile
    : currentBanner.marketing_banner_config.image_url;

  // useEffect to know when the image loads, to prevent the page from jumping
  useEffect(() => {
    const img = new Image();
    const handleLoad = () => setIsImageLoaded(true);
    const handleError = () => setIsImageLoaded(true);
    img.addEventListener("load", handleLoad);
    img.addEventListener("error", handleError);
    img.src = imageUrl;

    return () => {
      img.removeEventListener("load", handleLoad);
      img.removeEventListener("error", handleError);
    };
  }, [imageUrl]);

  if (!isImageLoaded) {
    return <LoadingContainer />;
  }

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerButtonContainer}>
        <button
          type="button"
          className={styles.bannerButton}
          aria-label="View clinic loyalty program promotion"
          onClick={() => navigate({ to: currentBanner.marketing_banner_config.destination_url })}
        >
          <ImageComponent
            src={imageUrl}
            alt="Clinic loyalty program marketing banner"
            className={styles.bannerImage}
          />
        </button>
      </div>
    </div>
  );
};

export default LoyaltyProgramMarketingBanners;
